import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default () => {
  const cover = document.querySelector('.js-mobile-cover')
  const triggers = document.querySelectorAll('.js-toggle-mobile-cover')

  ;[...triggers].forEach(trigger => {
    trigger.addEventListener('click', e => {
      cover.classList.toggle('active')
      document.body.classList.toggle('menu-open')

      if (cover.classList.contains('active')) {
        disableBodyScroll(cover)
      } else {
        enableBodyScroll(cover)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/MobileNav.js